import { Async, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {InteractiveFormStateDto} from '../models/Interactive';

export enum InteractiveFormStateActionType {
    GET_INTERACTIVE_FORM_STATES = 'interactive/GET_INTERACTIVE_FORM_STATES',
    CHANGE_INTERACTIVE_FORM_STATES = 'interactive/CHANGE_INTERACTIVE_FORM_STATES',
}

export const getInteractiveFormStates = (interactiveFormState: InteractiveFormStateDto) => createAction(InteractiveFormStateActionType.GET_INTERACTIVE_FORM_STATES, interactiveFormState);

export const changeInteractiveFormStates = (interactiveFormStates: Async<InteractiveFormStateDto[]>) => createAction(InteractiveFormStateActionType.CHANGE_INTERACTIVE_FORM_STATES, {interactiveFormStates});

type InteractiveFormStates = Async<InteractiveFormStateDto[]>;

export const DEFAULT_STATE: InteractiveFormStates = new Empty();


type InteractiveFormStateAction =
    | ReturnType<typeof changeInteractiveFormStates>
    | ReturnType<typeof getInteractiveFormStates>;

export default (state: InteractiveFormStates = DEFAULT_STATE, action: InteractiveFormStateAction): InteractiveFormStates => {
    switch (action.type) {
        case InteractiveFormStateActionType.CHANGE_INTERACTIVE_FORM_STATES:
            return {
                ...action.payload.interactiveFormStates,
            };
        default:
            return state;
    }
};
